import styled from '@emotion/styled'
import cx from 'classnames'

import { Icon } from '@/legacy/components/Icon'

import type { CoreIcon, LazyIcon } from '../Icon/types'
import { BodyP } from '../Typography'
import { VisuallyHidden } from '../VisuallyHidden'
export type Icon = CoreIcon | LazyIcon

interface ReadingTimeProps {
  readingTime?: string
  labelReadingTime?: string
  hightlightText?: boolean
  icon?: Icon
}
export const TypographyReadingStyles = styled(BodyP)`
  display: flex;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;

  span {
    margin-left: 0.2rem;
  }
`

const ReadingTime = ({
  readingTime,
  labelReadingTime = 'Tempo de leitura: ',
  hightlightText,
  icon = 'clock',
}: ReadingTimeProps) => {
  if (!readingTime) return null

  return (
    <>
      <TypographyReadingStyles color="dark-high" aria-hidden tag="span">
        <Icon width={16} height={16} icon={icon} svgProps={{ viewBox: '0 0 576 576' }} />
        <span>{labelReadingTime}</span>
        <span className={cx({ ['et-text-primary']: hightlightText })}>{readingTime}</span>
      </TypographyReadingStyles>
      <VisuallyHidden aria-describedby="readingTime">
        {labelReadingTime + readingTime}
      </VisuallyHidden>
    </>
  )
}
export default ReadingTime
